<mapfre-modal 
  [modalOptions]="walletDownloadModalOptions"
  [hideModal]="hideModal"
  [ngClass]="{'hide': !policyNumber }">
    <div 
      class="modal-body no-margin-bottom wallet-card"
      [ngClass]="{ 'flipped': onClickEventWalletPass }"
    >  
      <div class="wallet wallet-front">
        <div class="wallet-content">
          <app-onboarding-wallet-front></app-onboarding-wallet-front>
          <div class="wallet-footer margin-top mt24">
              <div class="margin-bottom mb24">
                  <mapfre-button 
                    additionalClasses="ghost white w280 h48 no-margin"
                    (click)="goToWalletPassModal($event)">
                    {{ 'WALLET_GET_MY_CARD' | translate }}
                  </mapfre-button>
                </div>
            </div>
          </div>
          <div class="wallet-skip-button">
            <mapfre-button
              additionalClasses="white-link link-button underline normal-link text-capitalize"
              (click)="hideModalAction($event)">
              {{ 'WALLET_SKIP' | translate }}
            </mapfre-button>
          </div>
      </div>
      <div class="wallet wallet-back d-flex align-items-center">
        <div class="wallet-back-button">
          <a (click)="goToWalletPassModal($event)">
            <img src="assets/img/icons/back-arrow.png" alt="back arrow icon"/>
          </a>
        </div>
        <div class="mx-auto">
          <div class="wallet-content back">
            <div class="wallet-back-headline">
              <div class="margin-bottom mb8 back-slide-title">
                {{ 'WALLETBACK_TITLE' | translate }}
              </div>
              <div class="margin-bottom mb40">
                <img src="assets/img/images/mapfre-card-logo-color.png" alt="mapfre card logo"  width="233" />
              </div>
            </div>
            <app-onboarding-wallet-back [policyNumber]="policyNumber"></app-onboarding-wallet-back>
          </div>
        </div>
        <div class="wallet-skip-button">
          <mapfre-button
            additionalClasses="blue-link link-button underline normal-link text-capitalize"
            (click)="hideModalAction($event)">
            {{ 'WALLET_SKIP' | translate }}
          </mapfre-button>
        </div>
      </div>
    </div>
</mapfre-modal>



